var _slicedToArray = require("/home/kieran/Projects/FYP/react-typescript-firebase/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _asyncToGenerator = require("/home/kieran/Projects/FYP/react-typescript-firebase/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
!function (global, factory) {
  "object" == typeof exports && "undefined" != typeof module ? factory(exports) : "function" == typeof define && define.amd ? define(["exports"], factory) : factory((global = "undefined" != typeof globalThis ? globalThis : global || self).loadPyodide = {});
}(this, function (exports) {
  "use strict";

  "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
  var errorStackParser = {
      exports: {}
    },
    stackframe = {
      exports: {}
    };
  !function (module, exports) {
    module.exports = function () {
      function _isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
      }
      function _capitalize(str) {
        return str.charAt(0).toUpperCase() + str.substring(1);
      }
      function _getter(p) {
        return function () {
          return this[p];
        };
      }
      var booleanProps = ["isConstructor", "isEval", "isNative", "isToplevel"],
        numericProps = ["columnNumber", "lineNumber"],
        stringProps = ["fileName", "functionName", "source"],
        arrayProps = ["args"],
        objectProps = ["evalOrigin"],
        props = booleanProps.concat(numericProps, stringProps, arrayProps, objectProps);
      function StackFrame(obj) {
        if (obj) for (var i = 0; i < props.length; i++) void 0 !== obj[props[i]] && this["set" + _capitalize(props[i])](obj[props[i]]);
      }
      StackFrame.prototype = {
        getArgs: function getArgs() {
          return this.args;
        },
        setArgs: function setArgs(v) {
          if ("[object Array]" !== Object.prototype.toString.call(v)) throw new TypeError("Args must be an Array");
          this.args = v;
        },
        getEvalOrigin: function getEvalOrigin() {
          return this.evalOrigin;
        },
        setEvalOrigin: function setEvalOrigin(v) {
          if (v instanceof StackFrame) this.evalOrigin = v;else {
            if (!(v instanceof Object)) throw new TypeError("Eval Origin must be an Object or StackFrame");
            this.evalOrigin = new StackFrame(v);
          }
        },
        toString: function toString() {
          var fileName = this.getFileName() || "",
            lineNumber = this.getLineNumber() || "",
            columnNumber = this.getColumnNumber() || "",
            functionName = this.getFunctionName() || "";
          return this.getIsEval() ? fileName ? "[eval] (" + fileName + ":" + lineNumber + ":" + columnNumber + ")" : "[eval]:" + lineNumber + ":" + columnNumber : functionName ? functionName + " (" + fileName + ":" + lineNumber + ":" + columnNumber + ")" : fileName + ":" + lineNumber + ":" + columnNumber;
        }
      }, StackFrame.fromString = function (str) {
        var argsStartIndex = str.indexOf("("),
          argsEndIndex = str.lastIndexOf(")"),
          functionName = str.substring(0, argsStartIndex),
          args = str.substring(argsStartIndex + 1, argsEndIndex).split(","),
          locationString = str.substring(argsEndIndex + 1);
        if (0 === locationString.indexOf("@")) var parts = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(locationString, ""),
          fileName = parts[1],
          lineNumber = parts[2],
          columnNumber = parts[3];
        return new StackFrame({
          functionName: functionName,
          args: args || void 0,
          fileName: fileName,
          lineNumber: lineNumber || void 0,
          columnNumber: columnNumber || void 0
        });
      };
      for (var i = 0; i < booleanProps.length; i++) StackFrame.prototype["get" + _capitalize(booleanProps[i])] = _getter(booleanProps[i]), StackFrame.prototype["set" + _capitalize(booleanProps[i])] = function (p) {
        return function (v) {
          this[p] = Boolean(v);
        };
      }(booleanProps[i]);
      for (var j = 0; j < numericProps.length; j++) StackFrame.prototype["get" + _capitalize(numericProps[j])] = _getter(numericProps[j]), StackFrame.prototype["set" + _capitalize(numericProps[j])] = function (p) {
        return function (v) {
          if (!_isNumber(v)) throw new TypeError(p + " must be a Number");
          this[p] = Number(v);
        };
      }(numericProps[j]);
      for (var k = 0; k < stringProps.length; k++) StackFrame.prototype["get" + _capitalize(stringProps[k])] = _getter(stringProps[k]), StackFrame.prototype["set" + _capitalize(stringProps[k])] = function (p) {
        return function (v) {
          this[p] = String(v);
        };
      }(stringProps[k]);
      return StackFrame;
    }();
  }(stackframe), function (module, exports) {
    var StackFrame, FIREFOX_SAFARI_STACK_REGEXP, CHROME_IE_STACK_REGEXP, SAFARI_NATIVE_CODE_REGEXP;
    module.exports = (StackFrame = stackframe.exports, FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/, CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m, SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code])?$/, {
      parse: function parse(error) {
        if (void 0 !== error.stacktrace || void 0 !== error["opera#sourceloc"]) return this.parseOpera(error);
        if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
        if (error.stack) return this.parseFFOrSafari(error);
        throw new Error("Cannot parse given Error object");
      },
      extractLocation: function extractLocation(urlLike) {
        if (-1 === urlLike.indexOf(":")) return [urlLike];
        var parts = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(urlLike.replace(/[()]/g, ""));
        return [parts[1], parts[2] || void 0, parts[3] || void 0];
      },
      parseV8OrIE: function parseV8OrIE(error) {
        return error.stack.split("\n").filter(function (line) {
          return !!line.match(CHROME_IE_STACK_REGEXP);
        }, this).map(function (line) {
          line.indexOf("(eval ") > -1 && (line = line.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(,.*$)/g, ""));
          var sanitizedLine = line.replace(/^\s+/, "").replace(/\(eval code/g, "(").replace(/^.*?\s+/, ""),
            location = sanitizedLine.match(/ (\(.+\)$)/);
          sanitizedLine = location ? sanitizedLine.replace(location[0], "") : sanitizedLine;
          var locationParts = this.extractLocation(location ? location[1] : sanitizedLine),
            functionName = location && sanitizedLine || void 0,
            fileName = ["eval", "<anonymous>"].indexOf(locationParts[0]) > -1 ? void 0 : locationParts[0];
          return new StackFrame({
            functionName: functionName,
            fileName: fileName,
            lineNumber: locationParts[1],
            columnNumber: locationParts[2],
            source: line
          });
        }, this);
      },
      parseFFOrSafari: function parseFFOrSafari(error) {
        return error.stack.split("\n").filter(function (line) {
          return !line.match(SAFARI_NATIVE_CODE_REGEXP);
        }, this).map(function (line) {
          if (line.indexOf(" > eval") > -1 && (line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), -1 === line.indexOf("@") && -1 === line.indexOf(":")) return new StackFrame({
            functionName: line
          });
          var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/,
            matches = line.match(functionNameRegex),
            functionName = matches && matches[1] ? matches[1] : void 0,
            locationParts = this.extractLocation(line.replace(functionNameRegex, ""));
          return new StackFrame({
            functionName: functionName,
            fileName: locationParts[0],
            lineNumber: locationParts[1],
            columnNumber: locationParts[2],
            source: line
          });
        }, this);
      },
      parseOpera: function parseOpera(e) {
        return !e.stacktrace || e.message.indexOf("\n") > -1 && e.message.split("\n").length > e.stacktrace.split("\n").length ? this.parseOpera9(e) : e.stack ? this.parseOpera11(e) : this.parseOpera10(e);
      },
      parseOpera9: function parseOpera9(e) {
        for (var lineRE = /Line (\d+).*script (?:in )?(\S+)/i, lines = e.message.split("\n"), result = [], i = 2, len = lines.length; i < len; i += 2) {
          var match = lineRE.exec(lines[i]);
          match && result.push(new StackFrame({
            fileName: match[2],
            lineNumber: match[1],
            source: lines[i]
          }));
        }
        return result;
      },
      parseOpera10: function parseOpera10(e) {
        for (var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, lines = e.stacktrace.split("\n"), result = [], i = 0, len = lines.length; i < len; i += 2) {
          var match = lineRE.exec(lines[i]);
          match && result.push(new StackFrame({
            functionName: match[3] || void 0,
            fileName: match[2],
            lineNumber: match[1],
            source: lines[i]
          }));
        }
        return result;
      },
      parseOpera11: function parseOpera11(error) {
        return error.stack.split("\n").filter(function (line) {
          return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
        }, this).map(function (line) {
          var argsRaw,
            tokens = line.split("@"),
            locationParts = this.extractLocation(tokens.pop()),
            functionCall = tokens.shift() || "",
            functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0;
          functionCall.match(/\(([^)]*)\)/) && (argsRaw = functionCall.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
          var args = void 0 === argsRaw || "[arguments not available]" === argsRaw ? void 0 : argsRaw.split(",");
          return new StackFrame({
            functionName: functionName,
            args: args,
            fileName: locationParts[0],
            lineNumber: locationParts[1],
            columnNumber: locationParts[2],
            source: line
          });
        }, this);
      }
    });
  }(errorStackParser);
  var ErrorStackParser = errorStackParser.exports;
  var IN_NODE = "undefined" != typeof process && process.release && "node" === process.release.name && void 0 === process.browser;
  var nodeUrlMod, nodeFetch, nodePath, nodeVmMod, nodeFsPromisesMod, resolvePath, pathSep, loadBinaryFile, loadScript;
  if (resolvePath = IN_NODE ? function (path, base) {
    return nodePath.resolve(base || ".", path);
  } : function (path, base) {
    return void 0 === base && (base = location), new URL(path, base).toString();
  }, IN_NODE || (pathSep = "/"), loadBinaryFile = IN_NODE ? /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(path, _file_sub_resource_hash) {
      var response, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(path.startsWith("file://") && (path = path.slice("file://".length)), path.includes("://"))) {
              _context.next = 11;
              break;
            }
            _context.next = 3;
            return nodeFetch(path);
          case 3:
            response = _context.sent;
            if (response.ok) {
              _context.next = 6;
              break;
            }
            throw new Error("Failed to load '".concat(path, "': request failed."));
          case 6:
            _context.t0 = Uint8Array;
            _context.next = 9;
            return response.arrayBuffer();
          case 9:
            _context.t1 = _context.sent;
            return _context.abrupt("return", new _context.t0(_context.t1));
          case 11:
            _context.next = 13;
            return nodeFsPromisesMod.readFile(path);
          case 13:
            data = _context.sent;
            return _context.abrupt("return", new Uint8Array(data.buffer, data.byteOffset, data.byteLength));
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }() : /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(path, subResourceHash) {
      var url, options, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            url = new URL(path, location);
            options = subResourceHash ? {
              integrity: subResourceHash
            } : {};
            _context2.next = 4;
            return fetch(url, options);
          case 4:
            response = _context2.sent;
            if (response.ok) {
              _context2.next = 7;
              break;
            }
            throw new Error("Failed to load '".concat(url, "': request failed."));
          case 7:
            _context2.t0 = Uint8Array;
            _context2.next = 10;
            return response.arrayBuffer();
          case 10:
            _context2.t1 = _context2.sent;
            return _context2.abrupt("return", new _context2.t0(_context2.t1));
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }(), globalThis.document) loadScript = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(url) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return import( /* webpackIgnore: true */url);
          case 2:
            return _context3.abrupt("return", _context3.sent);
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function loadScript(_x5) {
      return _ref3.apply(this, arguments);
    };
  }();else if (globalThis.importScripts) loadScript = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(url) {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            globalThis.importScripts(url);
            _context4.next = 10;
            break;
          case 4:
            _context4.prev = 4;
            _context4.t0 = _context4["catch"](0);
            if (_context4.t0 instanceof TypeError) {
              _context4.next = 8;
              break;
            }
            throw _context4.t0;
          case 8:
            _context4.next = 10;
            return import( /* webpackIgnore: true */url);
          case 10:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 4]]);
    }));
    return function loadScript(_x6) {
      return _ref4.apply(this, arguments);
    };
  }();else {
    if (!IN_NODE) throw new Error("Cannot determine runtime environment");
    loadScript = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(url) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              url.startsWith("file://") && (url = url.slice("file://".length));
              if (!url.includes("://")) {
                _context5.next = 11;
                break;
              }
              _context5.t0 = nodeVmMod;
              _context5.next = 5;
              return nodeFetch(url);
            case 5:
              _context5.next = 7;
              return _context5.sent.text();
            case 7:
              _context5.t1 = _context5.sent;
              _context5.t0.runInThisContext.call(_context5.t0, _context5.t1);
              _context5.next = 13;
              break;
            case 11:
              _context5.next = 13;
              return import( /* webpackIgnore: true */nodeUrlMod.pathToFileURL(url).href);
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function loadScript(_x7) {
        return _ref5.apply(this, arguments);
      };
    }();
  }
  function __values(o) {
    var s = "function" == typeof Symbol && Symbol.iterator,
      m = s && o[s],
      i = 0;
    if (m) return m.call(o);
    if (o && "number" == typeof o.length) return {
      next: function next() {
        return o && i >= o.length && (o = void 0), {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }
  function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var i,
      m = o[Symbol.asyncIterator];
    return m ? m.call(o) : (o = __values(o), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
      return this;
    }, i);
    function verb(n) {
      i[n] = o[n] && function (v) {
        return new Promise(function (resolve, reject) {
          (function (resolve, reject, d, v) {
            Promise.resolve(v).then(function (v) {
              resolve({
                value: v,
                done: d
              });
            }, reject);
          })(resolve, reject, (v = o[n](v)).done, v.value);
        });
      };
    }
  }
  var getFsHandles = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dirHandle) {
      var handles, result, _i, _handles, handle, relativePath;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            handles = [];
            _context7.next = 3;
            return function () {
              var _collect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(curDirHandle) {
                var e_1, _a, _c, _b, entry;
                return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.prev = 0;
                      _b = __asyncValues(curDirHandle.values());
                    case 2:
                      _context6.next = 4;
                      return _b.next();
                    case 4:
                      if ((_c = _context6.sent).done) {
                        _context6.next = 13;
                        break;
                      }
                      entry = _c.value;
                      handles.push(entry);
                      _context6.t0 = "directory" === entry.kind;
                      if (!_context6.t0) {
                        _context6.next = 11;
                        break;
                      }
                      _context6.next = 11;
                      return collect(entry);
                    case 11:
                      _context6.next = 2;
                      break;
                    case 13:
                      _context6.next = 18;
                      break;
                    case 15:
                      _context6.prev = 15;
                      _context6.t1 = _context6["catch"](0);
                      e_1 = {
                        error: _context6.t1
                      };
                    case 18:
                      _context6.prev = 18;
                      _context6.prev = 19;
                      _context6.t2 = _c && !_c.done && (_a = _b.return);
                      if (!_context6.t2) {
                        _context6.next = 24;
                        break;
                      }
                      _context6.next = 24;
                      return _a.call(_b);
                    case 24:
                      _context6.prev = 24;
                      if (!e_1) {
                        _context6.next = 27;
                        break;
                      }
                      throw e_1.error;
                    case 27:
                      return _context6.finish(24);
                    case 28:
                      return _context6.finish(18);
                    case 29:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6, null, [[0, 15, 18, 29], [19,, 24, 28]]);
              }));
              function collect(_x9) {
                return _collect.apply(this, arguments);
              }
              return collect;
            }()(dirHandle);
          case 3:
            result = new Map();
            result.set(".", dirHandle);
            _i = 0, _handles = handles;
          case 6:
            if (!(_i < _handles.length)) {
              _context7.next = 15;
              break;
            }
            handle = _handles[_i];
            _context7.next = 10;
            return dirHandle.resolve(handle);
          case 10:
            relativePath = _context7.sent.join("/");
            result.set(relativePath, handle);
          case 12:
            _i++;
            _context7.next = 6;
            break;
          case 15:
            return _context7.abrupt("return", result);
          case 16:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function getFsHandles(_x8) {
      return _ref6.apply(this, arguments);
    };
  }();
  function finalizeBootstrap(API, config) {
    API.runPythonInternal_dict = API._pyodide._base.eval_code("{}"), API.importlib = API.runPythonInternal("import importlib; importlib");
    var import_module = API.importlib.import_module;
    API.sys = import_module("sys"), API.sys.path.insert(0, config.homedir), API.os = import_module("os");
    var globals = API.runPythonInternal("import __main__; __main__.__dict__"),
      builtins = API.runPythonInternal("import builtins; builtins.__dict__");
    var builtins_dict;
    API.globals = (builtins_dict = builtins, new Proxy(globals, {
      get: function get(target, symbol) {
        return "get" === symbol ? function (key) {
          var result = target.get(key);
          return void 0 === result && (result = builtins_dict.get(key)), result;
        } : "has" === symbol ? function (key) {
          return target.has(key) || builtins_dict.has(key);
        } : Reflect.get(target, symbol);
      }
    }));
    var importhook = API._pyodide._importhook;
    importhook.register_js_finder(), importhook.register_js_module("js", config.jsglobals);
    var pyodide = API.makePublicAPI();
    return importhook.register_js_module("pyodide_js", pyodide), API.pyodide_py = import_module("pyodide"), API.pyodide_code = import_module("pyodide.code"), API.pyodide_ffi = import_module("pyodide.ffi"), API.package_loader = import_module("pyodide._package_loader"), API.sitepackages = API.package_loader.SITE_PACKAGES.__str__(), API.dsodir = API.package_loader.DSO_DIR.__str__(), API.defaultLdLibraryPath = [API.dsodir, API.sitepackages], API.os.environ.__setitem__("LD_LIBRARY_PATH", API.defaultLdLibraryPath.join(":")), pyodide.pyodide_py = API.pyodide_py, pyodide.globals = API.globals, pyodide;
  }
  function loadPyodide() {
    return _loadPyodide.apply(this, arguments);
  }
  function _loadPyodide() {
    _loadPyodide = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
      var options,
        indexURL,
        default_config,
        config,
        pyodide_py_tar_promise,
        Module,
        API,
        moduleLoaded,
        scriptSrc,
        pyodide_py_tar,
        _API$rawRun,
        _API$rawRun2,
        err,
        captured_stderr,
        pyodide,
        _args15 = arguments;
      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            options = _args15.length > 0 && _args15[0] !== undefined ? _args15[0] : {};
            _context15.next = 3;
            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
              var node_modules;
              return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                while (1) switch (_context8.prev = _context8.next) {
                  case 0:
                    if (IN_NODE) {
                      _context8.next = 2;
                      break;
                    }
                    return _context8.abrupt("return");
                  case 2:
                    _context8.next = 4;
                    return import("url");
                  case 4:
                    nodeUrlMod = _context8.sent.default;
                    _context8.next = 7;
                    return import("fs/promises");
                  case 7:
                    nodeFsPromisesMod = _context8.sent;
                    if (!globalThis.fetch) {
                      _context8.next = 12;
                      break;
                    }
                    _context8.t0 = fetch;
                    _context8.next = 15;
                    break;
                  case 12:
                    _context8.next = 14;
                    return import("node-fetch");
                  case 14:
                    _context8.t0 = _context8.sent.default;
                  case 15:
                    nodeFetch = _context8.t0;
                    _context8.next = 18;
                    return import("vm");
                  case 18:
                    nodeVmMod = _context8.sent.default;
                    _context8.next = 21;
                    return import("path");
                  case 21:
                    nodePath = _context8.sent;
                    pathSep = nodePath.sep;
                    if (!("undefined" != typeof require)) {
                      _context8.next = 25;
                      break;
                    }
                    return _context8.abrupt("return");
                  case 25:
                    _context8.next = 27;
                    return import("fs");
                  case 27:
                    _context8.t1 = _context8.sent;
                    _context8.next = 30;
                    return import("crypto");
                  case 30:
                    _context8.t2 = _context8.sent;
                    _context8.next = 33;
                    return import("ws");
                  case 33:
                    _context8.t3 = _context8.sent;
                    _context8.next = 36;
                    return import("child_process");
                  case 36:
                    _context8.t4 = _context8.sent;
                    node_modules = {
                      fs: _context8.t1,
                      crypto: _context8.t2,
                      ws: _context8.t3,
                      child_process: _context8.t4
                    };
                    globalThis.require = function (mod) {
                      return node_modules[mod];
                    };
                  case 39:
                  case "end":
                    return _context8.stop();
                }
              }, _callee8);
            }))();
          case 3:
            indexURL = options.indexURL || function () {
              if ("string" == typeof __dirname) return __dirname;
              var err;
              try {
                throw new Error();
              } catch (e) {
                err = e;
              }
              var fileName = ErrorStackParser.parse(err)[0].fileName;
              var indexOfLastSlash = fileName.lastIndexOf(pathSep);
              if (-1 === indexOfLastSlash) throw new Error("Could not extract indexURL path from pyodide module location");
              return fileName.slice(0, indexOfLastSlash);
            }();
            indexURL = resolvePath(indexURL), indexURL.endsWith("/") || (indexURL += "/"), options.indexURL = indexURL;
            default_config = {
              fullStdLib: !1,
              jsglobals: globalThis,
              stdin: globalThis.prompt ? globalThis.prompt : void 0,
              homedir: "/home/pyodide",
              lockFileURL: indexURL + "repodata.json",
              args: [],
              _node_mounts: []
            }, config = Object.assign(default_config, options), pyodide_py_tar_promise = loadBinaryFile(config.indexURL + "pyodide_py.tar"), Module = function () {
              var Module = {
                noImageDecoding: !0,
                noAudioDecoding: !0,
                noWasmDecoding: !1,
                preRun: [],
                quit: function quit(status, toThrow) {
                  throw Module.exited = {
                    status: status,
                    toThrow: toThrow
                  }, toThrow;
                }
              };
              return Module;
            }();
            Module.print = config.stdout, Module.printErr = config.stderr, Module.preRun.push(function () {
              var _iterator = _createForOfIteratorHelper(config._node_mounts),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var mount = _step.value;
                  Module.FS.mkdirTree(mount), Module.FS.mount(Module.NODEFS, {
                    root: mount
                  }, mount);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }), Module.arguments = config.args;
            API = {
              config: config
            };
            Module.API = API, function (Module, path) {
              Module.preRun.push(function () {
                try {
                  Module.FS.mkdirTree(path);
                } catch (e) {
                  console.error("Error occurred while making a home directory '".concat(path, "':")), console.error(e), console.error("Using '/' for a home directory instead"), path = "/";
                }
                Module.ENV.HOME = path, Module.FS.chdir(path);
              });
            }(Module, config.homedir);
            moduleLoaded = new Promise(function (r) {
              return Module.postRun = r;
            });
            if (!(Module.locateFile = function (path) {
              return config.indexURL + path;
            }, "function" != typeof _createPyodideModule)) {
              _context15.next = 14;
              break;
            }
            scriptSrc = "".concat(config.indexURL, "pyodide.asm.js");
            _context15.next = 14;
            return loadScript(scriptSrc);
          case 14:
            _context15.next = 16;
            return _createPyodideModule(Module);
          case 16:
            _context15.next = 18;
            return moduleLoaded;
          case 18:
            if (!Module.exited) {
              _context15.next = 20;
              break;
            }
            throw Module.exited.toThrow;
          case 20:
            if (!("0.22.1" !== API.version)) {
              _context15.next = 22;
              break;
            }
            throw new Error("Pyodide version does not match: '0.22.1' <==> '".concat(API.version, "'. If you updated the Pyodide version, make sure you also updated the 'indexURL' parameter passed to loadPyodide."));
          case 22:
            Module.locateFile = function (path) {
              throw new Error("Didn't expect to load any more file_packager files!");
            }, function (module) {
              var FS = module.FS,
                MEMFS = module.FS.filesystems.MEMFS,
                PATH = module.PATH,
                nativeFSAsync = {
                  DIR_MODE: 16895,
                  FILE_MODE: 33279,
                  mount: function mount(_mount) {
                    if (!_mount.opts.fileSystemHandle) throw new Error("opts.fileSystemHandle is required");
                    return MEMFS.mount.apply(null, arguments);
                  },
                  syncfs: function () {
                    var _syncfs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(mount, populate, callback) {
                      var local, remote, src, dst;
                      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                        while (1) switch (_context9.prev = _context9.next) {
                          case 0:
                            _context9.prev = 0;
                            local = nativeFSAsync.getLocalSet(mount);
                            _context9.next = 4;
                            return nativeFSAsync.getRemoteSet(mount);
                          case 4:
                            remote = _context9.sent;
                            src = populate ? remote : local;
                            dst = populate ? local : remote;
                            _context9.next = 9;
                            return nativeFSAsync.reconcile(mount, src, dst);
                          case 9:
                            callback(null);
                            _context9.next = 15;
                            break;
                          case 12:
                            _context9.prev = 12;
                            _context9.t0 = _context9["catch"](0);
                            callback(_context9.t0);
                          case 15:
                          case "end":
                            return _context9.stop();
                        }
                      }, _callee9, null, [[0, 12]]);
                    }));
                    function syncfs(_x10, _x11, _x12) {
                      return _syncfs.apply(this, arguments);
                    }
                    return syncfs;
                  }(),
                  getLocalSet: function getLocalSet(mount) {
                    var entries = Object.create(null);
                    function isRealDir(p) {
                      return "." !== p && ".." !== p;
                    }
                    function toAbsolute(root) {
                      return function (p) {
                        return PATH.join2(root, p);
                      };
                    }
                    var check = FS.readdir(mount.mountpoint).filter(isRealDir).map(toAbsolute(mount.mountpoint));
                    for (; check.length;) {
                      var path = check.pop(),
                        stat = FS.stat(path);
                      FS.isDir(stat.mode) && check.push.apply(check, FS.readdir(path).filter(isRealDir).map(toAbsolute(path))), entries[path] = {
                        timestamp: stat.mtime,
                        mode: stat.mode
                      };
                    }
                    return {
                      type: "local",
                      entries: entries
                    };
                  },
                  getRemoteSet: function () {
                    var _getRemoteSet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(mount) {
                      var entries, handles, _iterator2, _step2, _step2$value, path, handle;
                      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                        while (1) switch (_context10.prev = _context10.next) {
                          case 0:
                            entries = Object.create(null);
                            _context10.next = 3;
                            return getFsHandles(mount.opts.fileSystemHandle);
                          case 3:
                            handles = _context10.sent;
                            _iterator2 = _createForOfIteratorHelper(handles);
                            _context10.prev = 5;
                            _iterator2.s();
                          case 7:
                            if ((_step2 = _iterator2.n()).done) {
                              _context10.next = 23;
                              break;
                            }
                            _step2$value = _slicedToArray(_step2.value, 2), path = _step2$value[0], handle = _step2$value[1];
                            _context10.t0 = "." !== path;
                            if (!_context10.t0) {
                              _context10.next = 21;
                              break;
                            }
                            if (!("file" === handle.kind)) {
                              _context10.next = 17;
                              break;
                            }
                            _context10.next = 14;
                            return handle.getFile();
                          case 14:
                            _context10.t1 = _context10.sent.lastModifiedDate;
                            _context10.next = 18;
                            break;
                          case 17:
                            _context10.t1 = new Date();
                          case 18:
                            _context10.t2 = _context10.t1;
                            _context10.t3 = "file" === handle.kind ? nativeFSAsync.FILE_MODE : nativeFSAsync.DIR_MODE;
                            entries[PATH.join2(mount.mountpoint, path)] = {
                              timestamp: _context10.t2,
                              mode: _context10.t3
                            };
                          case 21:
                            _context10.next = 7;
                            break;
                          case 23:
                            _context10.next = 28;
                            break;
                          case 25:
                            _context10.prev = 25;
                            _context10.t4 = _context10["catch"](5);
                            _iterator2.e(_context10.t4);
                          case 28:
                            _context10.prev = 28;
                            _iterator2.f();
                            return _context10.finish(28);
                          case 31:
                            return _context10.abrupt("return", {
                              type: "remote",
                              entries: entries,
                              handles: handles
                            });
                          case 32:
                          case "end":
                            return _context10.stop();
                        }
                      }, _callee10, null, [[5, 25, 28, 31]]);
                    }));
                    function getRemoteSet(_x13) {
                      return _getRemoteSet.apply(this, arguments);
                    }
                    return getRemoteSet;
                  }(),
                  loadLocalEntry: function loadLocalEntry(path) {
                    var node = FS.lookupPath(path).node,
                      stat = FS.stat(path);
                    if (FS.isDir(stat.mode)) return {
                      timestamp: stat.mtime,
                      mode: stat.mode
                    };
                    if (FS.isFile(stat.mode)) return node.contents = MEMFS.getFileDataAsTypedArray(node), {
                      timestamp: stat.mtime,
                      mode: stat.mode,
                      contents: node.contents
                    };
                    throw new Error("node type not supported");
                  },
                  storeLocalEntry: function storeLocalEntry(path, entry) {
                    if (FS.isDir(entry.mode)) FS.mkdirTree(path, entry.mode);else {
                      if (!FS.isFile(entry.mode)) throw new Error("node type not supported");
                      FS.writeFile(path, entry.contents, {
                        canOwn: !0
                      });
                    }
                    FS.chmod(path, entry.mode), FS.utime(path, entry.timestamp, entry.timestamp);
                  },
                  removeLocalEntry: function removeLocalEntry(path) {
                    var stat = FS.stat(path);
                    FS.isDir(stat.mode) ? FS.rmdir(path) : FS.isFile(stat.mode) && FS.unlink(path);
                  },
                  loadRemoteEntry: function () {
                    var _loadRemoteEntry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(handle) {
                      var file;
                      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                        while (1) switch (_context11.prev = _context11.next) {
                          case 0:
                            if (!("file" === handle.kind)) {
                              _context11.next = 12;
                              break;
                            }
                            _context11.next = 3;
                            return handle.getFile();
                          case 3:
                            file = _context11.sent;
                            _context11.t0 = Uint8Array;
                            _context11.next = 7;
                            return file.arrayBuffer();
                          case 7:
                            _context11.t1 = _context11.sent;
                            _context11.t2 = new _context11.t0(_context11.t1);
                            _context11.t3 = nativeFSAsync.FILE_MODE;
                            _context11.t4 = file.lastModifiedDate;
                            return _context11.abrupt("return", {
                              contents: _context11.t2,
                              mode: _context11.t3,
                              timestamp: _context11.t4
                            });
                          case 12:
                            if (!("directory" === handle.kind)) {
                              _context11.next = 14;
                              break;
                            }
                            return _context11.abrupt("return", {
                              mode: nativeFSAsync.DIR_MODE,
                              timestamp: new Date()
                            });
                          case 14:
                            throw new Error("unknown kind: " + handle.kind);
                          case 15:
                          case "end":
                            return _context11.stop();
                        }
                      }, _callee11);
                    }));
                    function loadRemoteEntry(_x14) {
                      return _loadRemoteEntry.apply(this, arguments);
                    }
                    return loadRemoteEntry;
                  }(),
                  storeRemoteEntry: function () {
                    var _storeRemoteEntry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(handles, path, entry) {
                      var parentDirHandle, handle, writable;
                      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                        while (1) switch (_context12.prev = _context12.next) {
                          case 0:
                            parentDirHandle = handles.get(PATH.dirname(path));
                            if (!FS.isFile(entry.mode)) {
                              _context12.next = 7;
                              break;
                            }
                            _context12.next = 4;
                            return parentDirHandle.getFileHandle(PATH.basename(path), {
                              create: !0
                            });
                          case 4:
                            _context12.t0 = _context12.sent;
                            _context12.next = 10;
                            break;
                          case 7:
                            _context12.next = 9;
                            return parentDirHandle.getDirectoryHandle(PATH.basename(path), {
                              create: !0
                            });
                          case 9:
                            _context12.t0 = _context12.sent;
                          case 10:
                            handle = _context12.t0;
                            if (!("file" === handle.kind)) {
                              _context12.next = 19;
                              break;
                            }
                            _context12.next = 14;
                            return handle.createWritable();
                          case 14:
                            writable = _context12.sent;
                            _context12.next = 17;
                            return writable.write(entry.contents);
                          case 17:
                            _context12.next = 19;
                            return writable.close();
                          case 19:
                            handles.set(path, handle);
                          case 20:
                          case "end":
                            return _context12.stop();
                        }
                      }, _callee12);
                    }));
                    function storeRemoteEntry(_x15, _x16, _x17) {
                      return _storeRemoteEntry.apply(this, arguments);
                    }
                    return storeRemoteEntry;
                  }(),
                  removeRemoteEntry: function () {
                    var _removeRemoteEntry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(handles, path) {
                      var parentDirHandle;
                      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                        while (1) switch (_context13.prev = _context13.next) {
                          case 0:
                            parentDirHandle = handles.get(PATH.dirname(path));
                            _context13.next = 3;
                            return parentDirHandle.removeEntry(PATH.basename(path));
                          case 3:
                            handles.delete(path);
                          case 4:
                          case "end":
                            return _context13.stop();
                        }
                      }, _callee13);
                    }));
                    function removeRemoteEntry(_x18, _x19) {
                      return _removeRemoteEntry.apply(this, arguments);
                    }
                    return removeRemoteEntry;
                  }(),
                  reconcile: function () {
                    var _reconcile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(mount, src, dst) {
                      var total, create, remove, handles, _i2, _create, path, relPath, handle, entry, _entry, _i3, _remove, _path, _relPath;
                      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                        while (1) switch (_context14.prev = _context14.next) {
                          case 0:
                            total = 0;
                            create = [];
                            Object.keys(src.entries).forEach(function (key) {
                              var e = src.entries[key],
                                e2 = dst.entries[key];
                              (!e2 || FS.isFile(e.mode) && e.timestamp.getTime() > e2.timestamp.getTime()) && (create.push(key), total++);
                            }), create.sort();
                            remove = [];
                            if (!(Object.keys(dst.entries).forEach(function (key) {
                              src.entries[key] || (remove.push(key), total++);
                            }), remove.sort().reverse(), !total)) {
                              _context14.next = 6;
                              break;
                            }
                            return _context14.abrupt("return");
                          case 6:
                            handles = "remote" === src.type ? src.handles : dst.handles;
                            _i2 = 0, _create = create;
                          case 8:
                            if (!(_i2 < _create.length)) {
                              _context14.next = 25;
                              break;
                            }
                            path = _create[_i2];
                            relPath = PATH.normalize(path.replace(mount.mountpoint, "/")).substring(1);
                            if (!("local" === dst.type)) {
                              _context14.next = 19;
                              break;
                            }
                            handle = handles.get(relPath);
                            _context14.next = 15;
                            return nativeFSAsync.loadRemoteEntry(handle);
                          case 15:
                            entry = _context14.sent;
                            nativeFSAsync.storeLocalEntry(path, entry);
                            _context14.next = 22;
                            break;
                          case 19:
                            _entry = nativeFSAsync.loadLocalEntry(path);
                            _context14.next = 22;
                            return nativeFSAsync.storeRemoteEntry(handles, relPath, _entry);
                          case 22:
                            _i2++;
                            _context14.next = 8;
                            break;
                          case 25:
                            _i3 = 0, _remove = remove;
                          case 26:
                            if (!(_i3 < _remove.length)) {
                              _context14.next = 38;
                              break;
                            }
                            _path = _remove[_i3];
                            if (!("local" === dst.type)) {
                              _context14.next = 32;
                              break;
                            }
                            nativeFSAsync.removeLocalEntry(_path);
                            _context14.next = 35;
                            break;
                          case 32:
                            _relPath = PATH.normalize(_path.replace(mount.mountpoint, "/")).substring(1);
                            _context14.next = 35;
                            return nativeFSAsync.removeRemoteEntry(handles, _relPath);
                          case 35:
                            _i3++;
                            _context14.next = 26;
                            break;
                          case 38:
                          case "end":
                            return _context14.stop();
                        }
                      }, _callee14);
                    }));
                    function reconcile(_x20, _x21, _x22) {
                      return _reconcile.apply(this, arguments);
                    }
                    return reconcile;
                  }()
                };
              module.FS.filesystems.NATIVEFS_ASYNC = nativeFSAsync;
            }(Module);
            _context15.next = 25;
            return pyodide_py_tar_promise;
          case 25:
            pyodide_py_tar = _context15.sent;
            !function (Module, pyodide_py_tar) {
              var stream = Module.FS.open("/pyodide_py.tar", "w");
              Module.FS.write(stream, pyodide_py_tar, 0, pyodide_py_tar.byteLength, void 0, !0), Module.FS.close(stream);
              var _Module$API$rawRun = Module.API.rawRun('\nfrom sys import version_info\npyversion = f"python{version_info.major}.{version_info.minor}"\nimport shutil\nshutil.unpack_archive("/pyodide_py.tar", f"/lib/{pyversion}/")\ndel shutil\nimport importlib\nimportlib.invalidate_caches()\ndel importlib\n'),
                _Module$API$rawRun2 = _slicedToArray(_Module$API$rawRun, 2),
                errcode = _Module$API$rawRun2[0],
                captured_stderr = _Module$API$rawRun2[1];
              errcode && Module.API.fatal_loading_error("Failed to unpack standard library.\n", captured_stderr), Module.FS.unlink("/pyodide_py.tar");
            }(Module, pyodide_py_tar);
            _API$rawRun = API.rawRun("import _pyodide_core"), _API$rawRun2 = _slicedToArray(_API$rawRun, 2), err = _API$rawRun2[0], captured_stderr = _API$rawRun2[1];
            err && Module.API.fatal_loading_error("Failed to import _pyodide_core\n", captured_stderr);
            pyodide = finalizeBootstrap(API, config);
            pyodide.version.includes("dev") || API.setCdnUrl("https://cdn.jsdelivr.net/pyodide/v".concat(pyodide.version, "/full/"));
            _context15.next = 33;
            return API.packageIndexReady;
          case 33:
            API._pyodide._importhook.register_module_not_found_hook(API._import_name_to_package_name);
            if (!("0.22.1" !== API.repodata_info.version)) {
              _context15.next = 36;
              break;
            }
            throw new Error("Lock file version doesn't match Pyodide version");
          case 36:
            API.package_loader.init_loaded_packages();
            _context15.t0 = config.fullStdLib;
            if (!_context15.t0) {
              _context15.next = 41;
              break;
            }
            _context15.next = 41;
            return pyodide.loadPackage(API._pyodide._importhook.UNVENDORED_STDLIBS);
          case 41:
            API.initializeStreams(config.stdin, config.stdout, config.stderr);
            return _context15.abrupt("return", pyodide);
          case 43:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }));
    return _loadPyodide.apply(this, arguments);
  }
  globalThis.loadPyodide = loadPyodide, exports.loadPyodide = loadPyodide, exports.version = "0.22.1", Object.defineProperty(exports, "__esModule", {
    value: !0
  });
});